import React from 'react';
import MaintenanceSVG from "../../assets/images/maintenance.svg";
import { IoIosRefresh } from "react-icons/io";
import Max_Logo from "../../assets/images/fbslogoinverse.svg";

const Maintenance: React.FC = () => {
  
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className='fixed bg-primary-light text-center  p-3 w-screen top-0 flex justify-center'>
      <img
              src={Max_Logo}
              alt="sidebar-logo"
              className=""
            />
      </div>
      <div className="flex flex-col items-center justify-center text-center min-h-screen">
        <img src={MaintenanceSVG} alt="Maintenance" className="w-[300px] h-[300px]" />
        <div className='text-primary-light font-medium mt-5 text-3xl'>
        Oops! We’re Down for Maintenance
        </div>
        <div className='font-normal mt-2 text-lg font-helveticaNeue text-[#848888]'>
        It looks like this page is temporarily unavailable. <br/>
        We’re currently performing some updates to improve your experience.
        </div>
        <button  
          onClick={() => window.history.back()}
          className="flex items-center justify-center text-[#17BE62] bg-secondary-light mt-4 rounded-lg py-3 px-5 text-white font-medium hover:bg-primary-light"
        > <IoIosRefresh className="mr-2 w-[1.5rem] h-[1.5rem]" /> Refresh
        </button>
      </div>
    </div>
  );
};

export default Maintenance;
